module.exports = __webpack_public_path__ + "static/media/mask14.c713eb4c.JPG";